



























import Vue from 'vue';
import Component from 'vue-class-component';
import { mapState } from 'vuex';
import ItemService from '../services/itemService';
import { AuthenticationModuleState } from '../types';

@Component({
  props: {
    item: Object
  },
  computed: {
    ...mapState<AuthenticationModuleState>('authenticationModule', {
      localUser: (state: AuthenticationModuleState) => state.localUser
    })
  }
})
export default class EditItem extends Vue {
  public itemService: ItemService | null = null;
  public errorMessage: string | null = null;

  public mounted() {
    this.itemService = new ItemService();
  }

  public onSave() {
    if (!this.itemService) {
      throw new Error('EditItem.onSave: itemService is null or undefined');
    }

    this.itemService.updateItem(this.$props.item)
      .then(() => {
        this.errorMessage = null;
        this.$emit('item-saved', this.$props.item);
      })
      .catch((reason: Error) => {
        this.errorMessage = reason.message;
      });
  }

  public onCancel() {
    this.$emit('cancel-pressed');
  }
}
